import { gql } from '@apollo/client';

export const GET_ME = gql`
query Membership {
  me {
    # Every organisation this person belongs to — what the Switch organisation entry is
    # shown or hidden by. Cheap: this query is already read by every role hook, so the
    # switcher costs no extra request.
    organisations {
      id
      name
    }
    organisation {
      name
      currentBlockTag {
        id
        code
        name
      }
      nextBlockTag {
        id
        code
        name
      }
      membership {
        isAdmin
        isTeacherPersona
        isCenterManager
        isCourseAdmin
        isContentReviewer
        isPartnerLeadership
        isPartnerMembershipOfficer
        canAccessLeadership
      }
    }
  }
}`;
